import React from 'react';
import {Grid, Row, Col} from 'react-bootstrap';


class Education extends React.Component{
  render(){
    const styleLocation ={
        float:'right',
        display:'inline-block',
      };
    return(
      <li>
        <Col xs={4} md={4}  lg={4} xl={4}>
          <strong>{this.props.degree}</strong> in <em>{this.props.field} at {this.props.schoolname}</em>    ({this.props.duration})
        </Col>
        <Col xs={8} md={8}  lg={8} xl={8}>
          <p style={styleLocation}> GPA ({this.props.gpa})</p>
        </Col>
      </li>
      );
  }
}

class WorkExperience extends React.Component{
  render(props){
    const styleLocation ={
    float:'right',
    display:'inline-block',
  };
  const responsibilities=this.props.responsibilities.map((responsibility) =>
    <p style={{width:"auto"}}>{responsibility} </p>
    );
    return (
      <div >
          <Row>
            <Col xs={4} md={4}  lg={4} xl={4}>
              <p> <strong>{this.props.position} at {this.props.company}</strong> ( {this.props.from} - {this.props.to} ) </p>
            </Col>
            <Col xs={8} md={8}  lg={8} xl={8}>
              <p style={styleLocation}> {this.props.location} </p>
            </Col>
          </Row>
            {responsibilities}
      </div>
    );
  }
  }

class Projects extends React.Component{
  render(props){
    const styleLocation ={
        float:'right',
        display:'inline-block',
      };
    return(
    <Grid>
      <Row>
        <Col xs={4} md={4}  lg={4} xl={4}>
          <h4>{this.props.title} </h4>
        </Col>
        <Col xs={8} md={8}  lg={8} xl={8}>
          <h4 style={styleLocation}><small> Project Tags : {this.props.projectTags}</small></h4>
        </Col>
      </Row>
      <Row>
        <Col xs={8} md={8}  lg={8} xl={8}>
          <p>{this.props.description}</p>
        </Col>
      </Row>
  </Grid> 
      
    );
  }
}

class Skills extends React.Component{
  render(props){
    return(
      <Grid>
          <Row>
            <Col xs={4} md={4}  lg={4} xl={4}>
                <h4>{this.props.title}:</h4>
            </Col>
              <Col xs={8} md={8}  lg={8} xl={8}>
                <p>{this.props.values}</p>
            </Col>
          </Row>
      </Grid>

      );
  }
}



class Home extends React.Component{
render(){
	return(
      <Grid>
      </Grid>

    );
}
}

class SSkills extends React.Component{
  render(){
    return(
    <Grid>
    <Row>
          <h3>Skills</h3>
            <Row>
              <Skills title="Software Engineering" values={"A Big fan of Test Driven Development with good skills in Object Oriented concepts, Software Requirements Elicitation and Specification, building User Stories and describing concepts in High Level languages using UML."}/>
            </Row>
            <Row>
              <Skills title={"Software Development"} values={"Developed amazing products on Java and C/C++ Backend servers. Extensively use Python, PHP and Bash scripts for deployment automation using git."} />
            </Row>
            <Row>
              <Skills title={"Programming/Scripting"} values={"Java (4 years), Python (3 years), R (2 years), Matlab (1 year), C/C++ (1 year) "}  />
            </Row>
            <Row>
              <Skills title={"Web Development"} values={"Developed websites with JavaScript Frameworks - React + Redux / Angular+ Express over Node with MongoDB and MySQL databases. Proficient with HTML5, CSS, Bootstrap with roughly 4 years of experience. Also developed UI for machine learnign and data Visualization models using Python with Flask as Front-end interface. Worked with PHP - WordPress (2 years when working on The Website Walas)"}  />
            </Row>
            <Row>
              <Skills title={"DevOps"} values={"Web Application Maintenance on AWS (1 year) and IBM BlueMix (6 months), Maintaining stand-alone Unix server (as Application and NoSQL DB Server) + Managing Deployment Pipeline for Web Applications (8 months), Teaching Best Development + Deployment Practices on stand-alone Unix servers (3 months). This site is built on redux and hosted on github using surge. Has been tested on Heroku as well."}  />
            </Row>
            <Row>
              <Skills title={"Development, Testing and Maintenance"} values={"Use Eclipse, Atom, Netbeans, Sublime Text and Pycharm as primary IDEs and Jupyter for scripting. Proficient with using Github and Bitbucket for deployment. Good knowledge of testing on Junit, Selenium and Mocha + Chai "}  />
            </Row>
          </Row>
          </Grid>
    );
  }

}
class PProjects extends React.Component{
  render(){
    return(
    <Grid>
    <Row>
        <h3>Projects</h3>
        <Row>
          <Projects title={"The HAPPY App (Thesis Topic)"} projectTags={"Python, MongoDB, CentOS, REST APIs"} description={"Developed a Machine Learning algorithm to replace Body Mass Index and applied it to an existing application"} />
        </Row>
        <Row>
          <Projects title={"QwikEyes"} projectTags={"Python, Java, Angular JavaScript, IBM Bluemix"} description={"Built a Python based backend for a Mobile App for two-way video communication for the visually impaired"} />
        </Row>
        <Row>
          <Projects title={"Thothlab"} projectTags={"Python, R, D3.js JavaScript"} description={"Developed a Data Analysis and Visualization tool to provide recommendations for online laboratories."} />
        </Row>
        <Row>
          <Projects title={"Violette"} projectTags={"Android SDK, Java, Google Cloud Engine, MongoDB"} description={"Won Hackathon by building an Android App to help kids with ADHD by improving their cognitive capabilities."} />
        </Row>
      </Row>
      </Grid>
    );
  }

}
class WWorkExperience extends React.Component{
  render(){
    return(
    <Grid width="900px">
    <Row>
          <h3>Work Experience</h3>
            <WorkExperience company={"Arizona State University / CIDSE"} companyUrl="" position={"Graduate Teaching Associate"} from={"Jan 2017"} to={"May 2017"} location={"Mesa, Arizona, United States of America"} responsibilities={
              ['Improved student performance for two classes of size 60+ each by providing them personalized coaching through office hours and email communication',
              'Provided guidance on best software development, testing and deployment practices to enhance software engineering skills',
              ]}/>
            <WorkExperience company={"Arizona State University / SHPRS"} companyUrl="" position={"Instructional Technology Aide"} from={"August 2017"} to={"Jan 2017"} location={"Tempe, Arizona, United States of America"} responsibilities={
              ['Assisting Faculty at School of History, Philosophy and Religious Studies (SHPRS) with course material for online and offline courses',
              'Responsible for developing supplemental materials for courses and course management at SHPRS',
              ]}/>
            <WorkExperience company={"The Website Walas"} position={"Sole Proprietor "} companyUrl="" from={"March 2014"} to={"August 2015"} location={"Mumbai, Maharashtra, India"} responsibilities={
              ['Built  and exited a Web and Mobile application development firm that provided software development, marketing and other complementary services',
              'Assembled a talented team of two managers and three developers before exiting the company to ensure service to clients up until the final exit round',
              ]}/>
            <WorkExperience company={"Make My Brand Social"} position={"Web Developer and SEO Expert"} companyUrl="" from={"Feb 2014"} to={"March 2015"} location={"Thane, Maharashtra, India"} responsibilities={
              ['Improved site performance in terms of speed, SEO and responsiveness up to 15% on multiple websites during the internship period for 3 clients in education sector',
              'Devised extensive plans and delegated tasks across a team of four to generate SEO reports on client websites'
              ]}/>
        </Row>
        </Grid>
    );
  }

}
class EEducation extends React.Component{
  render(){
    return(
    <Grid>
    <Row>
        <h3>Education</h3>
        <ul>
        <Row>
          <Education schoolname={"Arizona State University"} duration={"Aug 2015 to July 2017"} gpa={"3.89"} degree={"Master of Science"} field={"Computer Science"} />
        </Row>
        <Row>
          <Education schoolname={"Mumbai University"} duration={"Aug 2011 to May 2015"} gpa={"3.44"} degree={"Bachelor of Engineering"} field={"Computer Engineering"} />
        </Row>
        </ul>
      </Row>
      </Grid>
    );
  }

}

module.exports = {SSkills, PProjects, WWorkExperience, EEducation, Home}


// WEBPACK FOOTER //
// ./src/Home.js